import getters from './getters';
export default {
  pushModal(state, payload) {
    state.modals.push(payload);
    document.querySelector('html').style.overflow = 'hidden';
  },
  popModal(state) {
    state.modals.pop();
    if (!getters.isModalOpen(state)) {
      document.querySelector('html').style.overflow = 'visible';
    }
  },
  closeAllModals(state) {
    state.modals = [];
    document.querySelector('html').style.overflow = 'visible';
  },
  setResult(state, payload) {
    state.result = Object.assign(payload);
  },
};
